import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { configureStore } from './_store';
import registerServiceWorker from './registerServiceWorker';

import App from './containers/App';
import { BUHTABLE_RESET } from './_actions/buhtable';
import { USER_AUTHENTICATE_RESET } from './_actions/user';

const store = configureStore();

store.subscribe(() => {
    const { user, buhtable } = store.getState();
    if(buhtable.errorStatus === 401) {
        store.dispatch({ type: BUHTABLE_RESET });
        store.dispatch({ type: USER_AUTHENTICATE_RESET });
    }
})

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>, 
    document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js